var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "seller-center-title"
  }, [_c('h2', {
    staticClass: "title-text"
  }, [_vm._v("\n    " + _vm._s(_vm.titleText) + "\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "options-slot"
  }, [_vm._t("default")], 2)]);
}
var staticRenderFns = []

export { render, staticRenderFns }